import { Component } from "react"

import { Header, Footer } from "../widgets"

/* Page wrapper — desktop header + footer, mobile drawer lives inside Header */
class Block extends Component {

    render = () => {
        const { pageClass, children } = this.props
        return (
            <div className={`app${pageClass ? ` ${pageClass}` : ""}`}>
                <Header />
                <main>
                    {children}
                </main>
                <Footer />
            </div>
        )
    }
}

export default Block
